import {showExportedBundleTqo} from "../../../rpc/webrpc-client.gen.ts";
import {JsonEditor} from "json-edit-react";
import {createFileRoute} from "@tanstack/react-router";
import {useRefreshableInfallibleQuery} from "../../../util/tqrefresh.tsx";
import {PageBody, PageHeader, PageShell} from "../../../routing/shell.tsx";
import {TopBar} from "../../../components/TopBar.tsx";
import {useMothership} from "../../../tq/tqx.tsx";

interface ExportBundleViewProps {
    bundleId: string;
}

function ExportBundleView({bundleId}: ExportBundleViewProps) {
    const mama = useMothership();
    const exportTqrv
        = useRefreshableInfallibleQuery(showExportedBundleTqo(mama, {bundleId}));
    const exportBundleString = exportTqrv.data;
    if (!exportBundleString) {
        return null;
    }
    const exportBundle = JSON.parse(exportBundleString) as Record<string, unknown>;
    return <JsonEditor data={exportBundle} restrictEdit={true}/>
}

function ExportBundlePage() {
    const {id: bundleId} = Route.useParams();
    return <PageShell>
        <PageHeader><TopBar/></PageHeader>
        <PageBody>
            <ExportBundleView bundleId={bundleId}/>
        </PageBody>
    </PageShell>;

}

export const Route = createFileRoute("/_auth/export/bundle/$id")({
    component: ExportBundlePage,
});
